import { Component, OnInit } from '@angular/core';
import { PlatformCommand } from '@shared/commands/command-base';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import { Api } from '@shared/constants/common-field.constants';
import {DialogModel} from "@shared/models/dialog.model";

@Component({
    standalone: false,
    selector: 'app-cbc-notification-required-dialog-editor',
  templateUrl: './cbc-notification-required-dialog-editor.component.html',
  styleUrls: ['./cbc-notification-required-dialog-editor.component.scss']
})
export class CbcNotificationRequiredDialogEditorComponent implements OnInit, IDialogView {

  data: DialogModel;
  item: any;
  fieldDefinition: any;

  notificationDefaultValue: any;
  notificationOverwrite: boolean = false;
  overwrittenCellValue: any;
  notificationFilingModel: any;

  constructor() { }

  ngOnInit() {
    this.item = this.data.input['item'];
    this.fieldDefinition = this.data.input['fieldDefinition'];
    this.notificationDefaultValue = this.item.cells['NotificationRequiredDefaultValue'].displayText;
    const isNotificationRequiredOverwritten = this.item.cells['IsNotificationRequiredOverwritten'].displayText;
    this.overwrittenCellValue = this.item.cells['JT101'].displayText;
    //this.notificationFilingModel = this.item.cells['JT101_Model'].value;

    if(isNotificationRequiredOverwritten === 'Yes'){
      this.notificationOverwrite = true;
    }
  }
  onOkClicked (): boolean {
    this.data.input.NextExecutionCommand = this.getExecutionCommand();
    this.data.input.HasUpdate = this.HasUpdate();
    return true;
  }

  getExecutionCommand(){
    let command = new PlatformCommand('UpdateCbCComplianceCommand', Api.DueDateTracker);
    command.setValue('ItemId', this.item.id);
    command.setValue('IsNotificationRequired', this.overwrittenCellValue === 'Yes');
    command.setValue('IsNotificationRequiredOverwritten', this.notificationOverwrite);
    command.setValue('StrategyType', 'UpdateCbCNotificationRequiredStrategy');
    command.projectId = '[PROJECT_ID]';
    return command;
  }

  private HasUpdate(): boolean {
      if(this.overwrittenCellValue !== this.item.cells['JT101'].displayText) return true;
      else if(this.notificationOverwrite !== this.ConvertBoolean(this.item.cells['IsNotificationRequiredOverwritten'].displayText)){
        return true;
      }
      return false;
  }

  private ConvertBoolean = (value: any): boolean => value === 'Yes';

}
